/**
 * Whether the given request completed with a success status.
 */
export const didRequestSucceed = (request: XMLHttpRequest) => {
    const { status } = request;

    return status === 200 || status === 304;
};
